import { addMinutes, isAfter, isBefore } from 'date-fns';
import { ProgramAbstractEvent, type ProgramEvent, type ProgramEventInviteeRole } from 'models';
import type { EventData } from '../types';

export const isAfterJoinPeriod = (time: Date) => {
  const endTime = addMinutes(time, ProgramAbstractEvent.leaveOffset);
  return isAfter(new Date(), endTime);
};

export const isBeforeJoinPeriod = (role: ProgramEventInviteeRole, time: Date) => {
  const startTime = addMinutes(time, ProgramAbstractEvent.getEnterOffset(role));
  return isBefore(new Date(), startTime);
};

export const isJoinPeriod = (
  event: Pick<ProgramEvent, 'bmgId' | 'currentUserRole' | 'currentUserRsvp' | 'endTime' | 'startTime' | 'status'>,
) => {
  if (event.bmgId && event.currentUserRsvp === 'going' && event.status === 'published') {
    return !(isBeforeJoinPeriod(event.currentUserRole, event.startTime) || isAfterJoinPeriod(event.endTime));
  }

  return false;
};

export const isJoinPeriodNode = (event: EventData) => {
  if (!event.rsvp || !event.role) {
    return false;
  }

  if (event.rsvp === 'going' && event.status === 'active') {
    return !(isBeforeJoinPeriod(event.role, event.startTime) || isAfterJoinPeriod(event.endTime));
  }

  return false;
};
